import Navigation from '../classes/Navigation';

const trigger = document.querySelector('.js-hamburger');

if(trigger) {
    trigger.addEventListener('click', () => {
    	toggle_class( document.querySelector('.js-site-header-mask'), 'is-active' );
        toggle_class( document.querySelector('.js-site-header-navigation'), 'is-active' );
    });

    function toggle_class ( element, class_name ) {
    	if ( element.classList.contains( class_name ) ) {
    		element.classList.remove( class_name );
    	} else {
    		element.classList.add( class_name );
    	}
    }
}
